import { motion } from "framer-motion";
import { BusinessMenuNav } from "@/components/businesses/BusinessMenuNav";
import { ConnectedServicesExplorer } from "@/components/businesses/ConnectedServicesExplorer";
import { PageHeader } from "@/components/ui/PageHeader";
import { ExplorerSkeleton } from "@/components/ui/PageSkeleton";
import { deriveConnectedServiceStatus } from "@/lib/business-analytics";
import { useBusinessPlatformData } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function ConnectedServicesPage() {
  const { data, isLoading, error } = useBusinessPlatformData();

  const pendingCount =
    data?.services.filter((service) => deriveConnectedServiceStatus(service) === "pending").length ??
    0;

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="space-y-6"
    >
      <PageHeader
        title="Approvals"
        description="Review Connected Services applications from the Shft Control app. Approve to grant live access, or reject with a reason."
        showGreeting={false}
      />

      <BusinessMenuNav pendingCount={pendingCount} />

      {isLoading ? (
        <ExplorerSkeleton title="Connected services" />
      ) : error ? (
        <p className="text-sm text-red-600">Failed to load applications. Please try again.</p>
      ) : data ? (
        <ConnectedServicesExplorer services={data.services} businesses={data.businesses} />
      ) : null}
    </motion.div>
  );
}
